import catalog from './i18n.json'

type MessageCatalog = typeof catalog
export type Locale = 'fr' | 'en'
export type Messages = MessageCatalog[Locale]

export default (locale: Locale) => catalog[locale] ?? catalog.en
